export default IconGlassCocktail => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-glass-cocktail" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 21h8" />
  <path d="M12 15v6" />
  <path d="M12 5m-7 0a7 2 0 1 0 14 0a7 2 0 1 0 -14 0" />
  <path d="M5 5v.388c0 .432 .126 .853 .362 1.206l5 7.509c.633 .951 1.88 1.183 2.785 .517c.191 -.141 .358 -.316 .491 -.517l5 -7.509c.236 -.353 .362 -.774 .362 -1.206v-.388" />
</svg>`;